var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"validate"},[_vm._t("default"),(_vm.validator.showError)?_c('p',{staticClass:"error-txt",style:(_vm.validator.errorStyle)},[_vm._v(_vm._s(_vm.validatorMsg))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }